export default __webpack_public_path__ + "static/media/leader.abc60568.jpg";